export default __webpack_public_path__ + "static/media/decentralizationMngIcon.7421478c.svg";